import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { isEqual, cloneDeep } from 'lodash-es';
import { jsx } from '@emotion/react';

function InspectorFormProvider(props) {
  var value = props.value,
    initialForm = props.form,
    onChange = props.onChange,
    children = props.children;
  var form = initialForm !== null && initialForm !== void 0 ? initialForm : useForm({
    defaultValues: value.props,
    mode: 'onBlur'
  });
  var formValue = form.watch();
  var prevFormValueRef = useRef();
  useEffect(function () {
    if (!isEqual(prevFormValueRef.current, formValue)) {
      onChange(_objectSpread2(_objectSpread2({}, value), {}, {
        props: formValue
      }));
      prevFormValueRef.current = cloneDeep(formValue);
    }
  }, [formValue]);
  useEffect(function () {
    form.reset(value.props);
  }, [props.value.key]);
  return jsx(FormProvider, form, children);
}

export { InspectorFormProvider };
//# sourceMappingURL=InspectorFormProvider.js.map
